/*
 * Bella Mia listicle (/pages/7-sibot, layout/advertorial.liquid + sections/bm-lp-*.liquid).
 * 1. CTA click event: every CTA link carries data-bm-lp-cta="<mid|offer|faq|sticky>". On click it publishes the
 *    custom event 'bm_lp_cta_click' {position} through Shopify.analytics.publish (customer events / web pixels
 *    can subscribe to it). Guarded: nothing happens and nothing throws when Shopify.analytics is missing.
 *    The link itself is a plain /products/temporary-eye-tightener with no UTM (an internal UTM would overwrite
 *    the visit source in Shopify).
 * 2. Sticky bottom bar, mobile only (<750px): appears once the intro has scrolled out of view (sentinel
 *    [data-bm-lp-sticky-start]) and stays to the end. While it is on screen the page gets bottom padding equal to
 *    the bar's height (--bm-lp-sticky-h), so the bar never hides the end of the page. Hidden bar = inert.
 * Loaded by the layout and by the sticky section; it runs once.
 */
(function () {
  'use strict';
  if (window.__bmLpInit) return;
  window.__bmLpInit = true;

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('[data-bm-lp-cta]') : null;
      if (!link) return;
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('bm_lp_cta_click', { position: link.getAttribute('data-bm-lp-cta') || '' });
        }
      } catch (err) {
        /* analytics is optional; never block the click */
      }
    },
    true
  );

  function initSticky() {
    var bar = document.querySelector('[data-bm-lp-sticky]');
    if (!bar || bar.getAttribute('data-bm-lp-ready') === '1') return;
    bar.setAttribute('data-bm-lp-ready', '1');

    var start = document.querySelector('[data-bm-lp-sticky-start]');
    var mq = window.matchMedia('(max-width: 749px)');
    var root = document.documentElement;
    var past = !start || !('IntersectionObserver' in window);

    function measure() {
      root.style.setProperty('--bm-lp-sticky-h', bar.offsetHeight + 'px');
    }

    function apply() {
      var mobile = mq.matches;
      bar.hidden = !mobile;
      document.body.classList.toggle('bm-lp-has-sticky', mobile);
      var show = mobile && past;
      bar.classList.toggle('is-visible', show);
      if (show) {
        bar.removeAttribute('inert');
        bar.removeAttribute('aria-hidden');
      } else {
        bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', 'true');
      }
      if (mobile) measure();
    }

    if (start && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        past = !e.isIntersecting && e.boundingClientRect.top < 0;
        apply();
      }).observe(start);
    }

    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
    window.addEventListener('resize', function () { if (mq.matches) measure(); }, { passive: true });
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
  document.addEventListener('shopify:section:load', initSticky);
})();
